var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68945 44.4514V16.1096C9.68945 12.5425 11.4642 10.75 14.9959 10.75H26.0522C29.5838 10.75 31.3407 12.5425 31.3407 16.1096V44.4514",
    stroke: "#A020FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4043 21C40.2392 21 38.5 22.7392 38.5 24.9043V28.9328C38.5 31.0979 40.2392 32.8372 42.4043 32.8372C44.5695 32.8372 46.3087 31.0979 46.3087 28.9328V24.9043C46.3087 22.7392 44.5695 21 42.4043 21Z",
    fill: "#E7EDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3887 44.5894L41.3887 34.3672",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6016 22.1797C39.4365 22.1797 37.6973 23.9189 37.6973 26.084V30.1125C37.6973 32.2776 39.4365 34.0168 41.6016 34.0168C43.7667 34.0168 45.506 32.2776 45.506 30.1125V26.084C45.506 23.9189 43.7667 22.1797 41.6016 22.1797Z",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1895 44.4514V16.1096C10.1895 12.5425 11.9642 10.75 15.4959 10.75H26.5522C30.0838 10.75 31.8407 12.5425 31.8407 16.1096V44.4514",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7559 20.0469H25.5406",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7559 23.5H25.5406",
    stroke: "#FF8165",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 44.5L36.5 44.5",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7559 26.7031H25.5406",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1035 44.452V37.7969",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.3c38b15b28aef32d079d8ae1e4f18114.svg";
export { ForwardRef as ReactComponent };